import auth from "./auth.json";
import common from "./common.json";
import dashboard from "./dashboard.json";
import errors from "./errors.json";
import products from "./products.json";
import takeAway from "./takeAway.json";
import allergens from "./allergens.json";
import meals from "./meals.json";
import feedback from "./feedback.json";
import reservations from "./reservations.json";
import settings from "./settings.json";
import vouchers from "./vouchers.json";
import healthcheck from "./healthcheck.json";
import website from "./website.json";
import onboarding from "./onboarding.json";
import calendar from "./calendar.json";
import tickets from "./tickets.json";
import experiences from "./experiences.json";
import marketing from "./marketing.json";
import group from "./group.json";
import noShowProtection from "./noShowProtection.json";
import coupons from "./coupons.json";
import managedWebsites from "./managedWebsites.json";
// The shop is German/English first; French shows the English texts for now.
import shop from "../en/shop.json";

const languages = {
  auth,
  common,
  dashboard,
  errors,
  products,
  takeAway,
  allergens,
  meals,
  feedback,
  reservations,
  settings,
  vouchers,
  healthcheck,
  website,
  onboarding,
  calendar,
  tickets,
  experiences,
  marketing,
  group,
  noShowProtection,
  coupons,
  managedWebsites,
  shop,
};

export default languages;
